export function PerSelector({per, setPer}) {
    return (
        <select name="per" value={per} onChange={e => setPer(e.target.value)}>
            <option value="two-weeks">Two Weeks</option>
            <option value="month">Month</option>
            <option value="year">Year</option>
        </select>
    );
}
